<div class="cab-tab" [ngClass]="class">
  <div class="stepper stepper-links d-flex flex-column">
    <div class="stepper-nav">
      @for (title of titles; track title; let i = $index) {
      <div
        (click)="onChangeStep(i)"
        [ngClass]="{ current: _cabTabService.currentStep === i }"
        class="stepper-item text-left"
      >
        <h3 class="stepper-title">
          <span class="title-cab">{{ title | translate }} </span>
        </h3>
      </div>
      }
    </div>
    <div class="current">
      @if (_cabTabService.currentStep === 0) {
      <ng-content select="#first"></ng-content>
      } @if (_cabTabService.currentStep === 1) {
      <ng-content select="#second"></ng-content>
      } @if (_cabTabService.currentStep === 2) {
      <ng-content select="#third"></ng-content>
      } @if (_cabTabService.currentStep === 3) {
      <ng-content select="#fourth"></ng-content>
      } @if (_cabTabService.currentStep === 4) {
      <ng-content select="#fifth"></ng-content>
      }
    </div>
  </div>
</div>
